import classnames from "classnames";
import { IconLoading } from "../../Icon/Icon.tsx";
import styles from "./Loading.module.css";

const Loading = ({ className, ...rest }: { className: string }) => (
  <div className={classnames(styles.loading, className)} {...rest}>
    <div>
      <IconLoading />
    </div>
  </div>
);

export default Loading;
